define('extensions/file.extensions',[], function() {

    function getApplicationTypeIcon(applicationType) {
        var path;
        var iconPath = "icon icon-{0}";
        applicationType = applicationType ? applicationType.toLowerCase() : null;
        switch (applicationType) {
            case "excel":
            case "word":
            case "powerpoint":
            case "pdf":
            case "zip":
            case "xml":
                path = String.format(iconPath, "file-" + applicationType);
                break;

            case "png":
            case "gif":
            case "jpg":
            case "jpeg":
                path = String.format(iconPath, "image");
                break;

            case "mail":
            case "email":
                path = String.format(iconPath, "envelope-alt");
                break;

            case "txt":
            case "text":
                path = String.format(iconPath, "file-txt");
                break;

            default:
                path = String.format(iconPath, "file");
        }
        return path;
    }

    return {
        getApplicationTypeIcon : getApplicationTypeIcon
    };

});
